import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import type {Referral} from "@khan/auth-shared";
import {mediaQueries} from "@khan/shared-styles";

import {
    isKhanmigoReferral,
    isLearnStormReferral,
} from "#auth/components/util.ts";

type Props = {
    referral?: Referral;
    detailScreenNode: React.ReactNode;
    actionScreenNode: React.ReactNode;
};

function ProgressShellFullLayout({
    referral,
    detailScreenNode,
    actionScreenNode,
}: Props): React.ReactElement<React.ComponentProps<"div">> {
    return (
        <View className={css(styles.progressShellFullLayout)}>
            {detailScreenNode && (
                <section
                    className={css(
                        styles.detailScreenContainer,
                        isKhanmigoReferral(referral || "") &&
                            styles.khanmigoDetailScreenContainer,
                        isLearnStormReferral(referral || "") &&
                            styles.learnStormDetailScreenContainer,
                    )}
                >
                    {detailScreenNode}
                </section>
            )}
            {actionScreenNode && (
                <section className={css(styles.actionScreenContainer)}>
                    {actionScreenNode}
                </section>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    progressShellFullLayout: {
        position: "relative",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        // needed because of the negative margin on actionScreenContainer
        overflow: "hidden",
        [mediaQueries.lgOrLarger]: {
            flexDirection: "row",
        },
        [mediaQueries.xs]: {
            width: "100%",
            minHeight: "100%",
        },
    },
    detailScreenContainer: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#2C533C",
        width: "100%",
        alignItems: "center",
        padding: "5%",
        justifyContent: "center",
        [mediaQueries.lgOrLarger]: {
            width: "50%",
            padding: "7.5%",
        },
        [mediaQueries.xlOrLarger]: {
            alignItems: "flex-end",
            padding: "10%",
        },
        // @ts-expect-error - TS2322 - not assignable to type 'CSSProperties'.
        "@media screen and (min-width: 1600px)": {
            paddingRight: 160,
            paddingTop: 160,
            paddingBottom: 160,
        },
    },
    khanmigoDetailScreenContainer: {
        backgroundColor: "#F7F2EA",
    },
    learnStormDetailScreenContainer: {
        backgroundColor: "#044760",
    },
    actionScreenContainer: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: color.white,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        [mediaQueries.mdOrLarger]: {
            padding: "5%",
        },
        [mediaQueries.lgOrLarger]: {
            width: "50%",
            padding: "7.5%",
            // This offsets the margin-top on the action screen inner which
            // we don't want modify since it's a shared component.
            marginTop: -85,
        },
        [mediaQueries.xlOrLarger]: {
            alignItems: "flex-start",
            padding: "10%",
        },
        // @ts-expect-error - TS2322 - not assignable to type 'CSSProperties'.
        "@media screen and (min-width: 1600px)": {
            paddingTop: 160,
            paddingBottom: 160,
            paddingLeft: 160,
        },
    },
});

export default ProgressShellFullLayout;
